import React from "react";
import AdminDaerahMenu from "../components/menu/admin/AdminDaerahMenu";

const AdminDaerah = () => {
  return <AdminDaerahMenu />;
};
export default AdminDaerah;